/**
  Here is the general concept. reducer factories define the least amount that
  they must. In other words, they should focus only on modifying the state
  they deal with. For example, uploadReducerFactory focuses entirely on state
  changes when uploading documents. When it must interact with other state
  information, it makes use of other factories as much as possible to use
  their already defined reducers to accomplish their state changes.

  Reducers can be composed by leveraging several factories. One "bringer together" factory
  is the documentReducerFactory, which provides basic entity operations such as
  paging and filtering, but also supports saving updates (via changeReducerFactory)
  and file uploads (via uploadReducerFactory). This big composition file
  shows how we can combine/pipeline reducers to get called one after another and
  compose the new state through use of multiple reducers. Combining is done with a
  reduceReducer() method, which just iteratively calls each reducer, applying the state
  changes, and feeding that new state into the next reducer.

  At the top of the food chain are the custom entity reducers like
  reportReducer, issueReducer, assetReducer. These classes
  instantiate the factories discussed above for their particular entity,
  and then they define any new/custom reducers they need for their particular
  entity. Again, they should be implemented using composition of previously
  defined reducers when possible.

  That last thing each of these entity reducers does is applyReducer, which
  just performs the basic redux function of applying an incoming action to
  the reducers and initial state.
 */
export default function applyReducer(reducers) {
  let initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // return the reducers function with the constants and entity
  // in context...
  /* eslint-disable-next-line default-param-last */
  return function () {
    let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    let action = arguments.length > 1 ? arguments[1] : undefined;
    // console.log('applying reducer to action', action);
    const reducerFunc = reducers[action.type] ? reducers[action.type] : () => state;
    return reducerFunc(state, action);
  };
}
export function setEntities(state, entityData) {
  return {
    list: entityData.slice(0)
  };
}

// this code is from an npm package reduceReducers
// https://github.com/acdlite/reduce-reducers/blob/master/src/index.js
export function reduceReducers() {
  for (var _len = arguments.length, reducers = new Array(_len), _key = 0; _key < _len; _key++) {
    reducers[_key] = arguments[_key];
  }
  return (previous, current) => reducers.reduce((p, r) => r(p, current), previous);
}